
















import Vue from 'vue'

import responseIcon from '@/assets/img/icons/auto-responder.svg'
import commentIcon from '@/assets/img/icons/description.svg'

export default Vue.extend({
  name: 'DdGlobalSearchAvatarRow',
  props: {
    /**
     * Activate search
     */
    item: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isReplyLogo: {
        src: responseIcon,
        alt: '',
      },
      isCommentLogo: {
        src: commentIcon,
        alt: '',
      },
    }
  },
})
